import { render, staticRenderFns } from "./no-results-message-extras.vue?vue&type=template&id=5f4d6404&scoped=true"
import script from "./no-results-message-extras.vue?vue&type=script&setup=true&lang=ts"
export * from "./no-results-message-extras.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./no-results-message-extras.vue?vue&type=style&index=0&id=5f4d6404&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d6404",
  null
  
)

export default component.exports